import React from 'react';

import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {CTAButtonFixed} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import type {UseTherapySessionsReturn} from '../TherapySessions/hooks/types';

const {saveTherapy} = translations['pt-br'].privateFlow.refund.therapies;

export function SaveButton({hookProps}: {hookProps: UseTherapySessionsReturn}) {
	const {isMobile} = useMediaQueries();
	const {formContext, handleSaveTherapy, isLoadingProcedures} = hookProps;

	const CtaButtonFixedDirection = () => {
		if (isMobile) {
			return 'column-reverse';
		}
		if (!isMobile) {
			return 'row';
		}

		return 'column';
	};

	return (
		<CTAButtonFixed.Root
			direction={CtaButtonFixedDirection()}
			justifyContent="flex-end"
			my={isMobile ? 0 : 2}
			px={isMobile ? 1 : 0}>
			<CTAButtonFixed.Action
				data-tag-id={RefundTaggingEnum.CLICK_CADASTRAR_NOVA_TERAPIA_REEMBOLSO}
				type="submit"
				size="large"
				disabled={isLoadingProcedures}
				variant="contained"
				color="primary"
				onClick={formContext.handleSubmit(handleSaveTherapy)}
				endIcon={isLoadingProcedures ? <Loading size={16} color="inherit" /> : null}>
				{saveTherapy}
			</CTAButtonFixed.Action>
		</CTAButtonFixed.Root>
	);
}
